export { SysqueTextButtonComponent } from './sysque-text-button.component';
export { SysqueTextButtonModule } from './sysque-text-button.module';